/**
 * Created by mateimisarca on 20.03.2021
 */

export const menu = [
  {
    slug: 'serii',
    icon: 'fas fa-landmark',
    path: '/admin/series',
    access: [],
  },
  {
    slug: 'inregistrati',
    icon: 'fas fa-landmark',
    path: '/admin/subscriptions',
    access: [],
  },
  {
    slug: 'rezultate',
    icon: 'fas fa-landmark',
    path: '/admin/results',
    access: [],
  },
]
